
import axiosInstance from '../axiosInstance';
import { useEffect, useMemo, useState, useRef } from 'react';
import { FaSearch } from 'react-icons/fa';

import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL_All } from '../api';
import * as general from '../libs/general';
import { fetchReconcilePartnerVatPermissions } from "../libs/customerCreatePermission";
import Paging from '../components/Paging';
import { CheckingTicket, LockingTicket, WarningIcon, EyeIcon } from '../components/tickets/Tickets';
import ContactOrderVatReview from '../components/orders/ContactOrderVatReview';
import AdLayout from '../components/AdLayout';
import DataTable from '../components/ui/DataTable';

const isContactSelectLocked = (contactingId) => contactingId === 14 || contactingId === 15;

function ContactVatOrders() {
  //const [pageData, setPageData] = useState({ content: [] });
  const [pageOrderData, setPageOrderData] = useState({ content: [] });
  const [errorMessage, setErrorMessage] = useState("");

  const [contactOrderVatData, setContactOrderVatData] = useState(null);

  const [selectedOrders, setSelectedOrders] = useState([]);

  const hasRun = useRef(false);

  const [customerCodes, setCustomerCodes] = useState("");
  const [customerVats, setCustomerVats] = useState("");
  const [params, setParams] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [reconcilePerm, setReconcilePerm] = useState({ loaded: false, canCreate: false });

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await axiosInstance.get(`/api/users/all`);
        const list = response.data.map(item => item.customerCode).filter(code => code);
        const uniqueList = [...new Set(list)];
        var joinedCodes = uniqueList.join(',');
        setCustomerCodes(joinedCodes);
      } catch (error) {
        console.error(error);
      }
    };

    fetchCustomers();
    searchOrders();
    //searchInvoices();
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const p = await fetchReconcilePartnerVatPermissions(axiosInstance);
      if (!cancelled) setReconcilePerm({ loaded: true, canCreate: Boolean(p?.canCreate) });
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleRefreshPage = (e) => {
    searchOrders();
    //searchInvoices();
  };


  const handleSearchCustomerChange = (e) => {
    var searchValue = e.target.value;

    var name = e.target.name;
    var newParams = { ...params };
    newParams[name] = e.target.value;
    setParams(newParams);

    var thTag = e.target.closest('.th-col');
    if (thTag) {
      var selectedTag = thTag.querySelector('.item_selected');
      if ((selectedTag && selectedTag.innerText === searchValue) || searchValue === '') {
        if (name === 'customerCode') {
          searchOrders({ page: 0, customerCode: searchValue, taxVat: '' });
        } else {
          searchOrders({ page: 0});
        }
      }
    }


  };

  const searchOrders = async (filter) => {
    if (window.calling) return;
    window.calling = true;

    setIsLoading(true);
    setErrorMessage('');

    var checkAllTag = document.querySelector('.check_all');
    if (checkAllTag) {
      checkAllTag.removeAttribute('data-unchecked');
      checkAllTag.checked = false;
    }
    setSelectedOrders([]);

    var params = general.getSession('contact_order_vat_filter');

    var formData = general.getFormData('#contact_order_vat_filter');
    Object.assign(params, formData);

    if (!hasRun.current) {
      hasRun.current = true;
      var oldParams = general.getSession('contact_order_vat_filter');
      Object.assign(params, oldParams);
    }

    if (filter) Object.assign(params, filter);
    general.setSession('contact_order_vat_filter', params);
    setParams(params);
    window.initializeFilterValue(params);


    var filteredParams = Object.fromEntries(Object.entries(params).filter(([key, v]) => v !== undefined && v !== '' && key + v !== 'page0' && key + v !== 'size550' && key + v !== 'isDeletedfalse'));

    var response = {};
    try {
      response = await axiosInstance.get('/api/import-orders/searchdetailsForContact', { params: filteredParams });
      setPageOrderData(response.data);
      var processedOrders = response.data.page.content;
      //debugger;
      if (params.status) {
        var statusNames = params.status.split(';');
        var listStatus = response.data.orderStatus;
        listStatus.forEach(obj => {
          if (statusNames.includes(obj.name)) {
            obj.active = true;
          }
        });
      }
      if (!params.taxVat) {
        var listVats = response.data.listTexts.join(',');
        setCustomerVats(listVats);
      }

      var checkAllTag = document.querySelector('.check_all');
      if (checkAllTag) {
        checkAllTag.removeAttribute('data-listIds');
        if (response.data.listIds) {
          checkAllTag.setAttribute('data-listIds', response.data.listIds.join(","));
        }
        var uncheckedList = checkAllTag.getAttribute('data-unchecked');
        if (uncheckedList || checkAllTag.checked) {
          if (!uncheckedList) uncheckedList = '';
          var uncheckedItems = uncheckedList.split(',').map(item => parseInt(item.trim())).filter(Number.isInteger);
          setSelectedOrders(processedOrders
            .filter(order => !uncheckedItems.includes(order.id) && !isContactSelectLocked(order.contactingId))
            .map(order => order.id));
        }
      }
    } catch (error) {
      setErrorMessage(error.message);
      console.error(error);
    } finally {
      window.calling = false;
    }

    setIsLoading(false);
  };

  const handleChangeItemsPerPage = (e) => {
    const newItemsPerPage = parseInt(e.target.value, 10);
    searchOrders({ page: 0, size: newItemsPerPage });
  };

  const handlePageChange = (page) => {
    searchOrders({ page: page - 1 });
  };

  const getSelectableListIds = () => {
    const content = pageOrderData.page?.content || [];
    const listIds = pageOrderData.listIds || content.map(o => o.id);
    const lockedIds = new Set(content.filter(o => isContactSelectLocked(o.contactingId)).map(o => o.id));
    return listIds.filter(id => !lockedIds.has(id));
  };

  const prepareChecking = async (params) => {
    if (!reconcilePerm.loaded || !reconcilePerm.canCreate) {
      toast.warning("Bạn không có quyền tạo đối soát.");
      return;
    }
    const content = pageOrderData.page?.content || [];
    const lockedIds = new Set(content.filter(o => isContactSelectLocked(o.contactingId)).map(o => o.id));
    const selectableIds = selectedOrders.filter(id => !lockedIds.has(id));
    if (selectableIds.length < selectedOrders.length) {
      toast.warning("Đã loại các đơn Vào phiếu / Đã đối soát khỏi danh sách tạo đối soát.");
      setSelectedOrders(selectableIds);
    }
    if (selectableIds.length === 0) {
      toast.error('Phải chọn ít nhất một mục.');
      return;
    }
    var reviewParams = { listIds: selectableIds };
    var isValid = await validateInvoice(reviewParams);
    if (isValid) setContactOrderVatData(reviewParams);
  };

  const validateInvoice = async (params) => {
    const textIds = params.listIds.join(';');
    try {
      var urlApi = `/api/invoices/getInvoiceContactVatReview?codes=${textIds}`;
      const response = await axiosInstance.get(urlApi);
      var obj = response.data;
      if (obj.success === false) {
        toast.error(obj.message);
        return false;
      }
    } catch (error) {
      console.error(error);
      toast.error(error.message);
      return false;
    }
    return true;
  }

  function removeItem(array, value) {
    return array.filter(item => item !== value);
  }
  const handleSelectOrder = (id) => {
    const order = pageOrderData.page?.content?.find(o => o.id === id);
    if (order && isContactSelectLocked(order.contactingId)) return;

    setSelectedOrders((prevSelected) => {
      const updated = prevSelected.includes(id)
        ? prevSelected.filter((orderId) => orderId !== id)
        : [...prevSelected, id];

      var totalNumberPages = pageOrderData.page.totalPages;
      var checkallTag = document.querySelector('.check_all');
      const selectableListIds = getSelectableListIds();
      if (totalNumberPages === 1 && selectableListIds.length) {
        const allChecked = selectableListIds.every(orderId => updated.includes(orderId));
        if (checkallTag) checkallTag.checked = allChecked;
      }
      var isChecked = updated.includes(id);
      var uncheckedList = checkallTag.getAttribute('data-unchecked');
      var idText = id + '';
      if (totalNumberPages > 1 && (checkallTag.checked || uncheckedList)) {
        if (!uncheckedList) uncheckedList = '';
        var uncheckedItems = uncheckedList.split(',').filter(str => str !== "");
        if (isChecked) {
          uncheckedItems = removeItem(uncheckedItems, idText);
        } else {
          var isExisted = uncheckedItems.includes(idText);
          if (!isExisted) uncheckedItems.push(idText);
        }
        var textUncheckedItems = uncheckedItems.join(',');

        if (textUncheckedItems) {
          checkallTag.setAttribute('data-unchecked', textUncheckedItems);
          checkallTag.checked = false;
        } else {

          checkallTag.removeAttribute('data-unchecked');
          checkallTag.checked = true;
        }
      }

      return updated;
    }
    );
  };
  const handleSelectAll = () => {
    var checkAllTag = document.querySelector('.check_all');
    checkAllTag.removeAttribute('data-unchecked');
    var isChecked = checkAllTag.checked;
    if (!isChecked) {
      setSelectedOrders([]);
    } else {
      setSelectedOrders(getSelectableListIds());
    }
  };

  return (
    <div>
      <AdLayout>
        <div className="table-responsive web-table">
          <div className="tab-container">
            <nav>
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button className="nav-link active">Đối tác: Đơn hàng VAT</button>
                <button className="nav-link"><Link to="/hoa-don-vat-doi-tac">Đối tác: Hóa đơn VAT</Link></button>
              </div>
            </nav>
            <div className="tab-content bg-white" id="nav-tabContent">
              <div className="tab-pane fade show active" id="pane-01" role="tabpanel" aria-labelledby="nav-home-tab">

                <div className="container-fluid pt-2">
                  <div className="text-start mb-2 normal-form">
                    <div className="row">
                      <div className="col-md-7">


                        <form id="contact_order_vat_filter">
                          <div className="row">
                            <div className="col-4 height-46">
                              <div className="row">
                                <label className="form-label col-form-label col-md-3 text-end">Mã KH</label>
                                <div className="col-md-9">
                                  <div className="th th-col filter-editor">
                                    <span className="filter-ib" data-source-url={API_URL_All + '/api/users/searchUserCodes'} >
                                      <input type="text" name="customerCode" placeholder="Nhập mã khách hàng..." autoComplete="off" onChange={(e) => handleSearchCustomerChange(e)} />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6 height-46">
                              <div className="row">
                                <label className="form-label col-form-label col-md-3 text-end">Mã đơn vận</label>
                                <div className="col-md-9">
                                  <div className="">
                                    <textarea name="chinaCodes" className="form-control" placeholder="Mã đơn vận"></textarea>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-2 p-0">

                              <button onClick={(event) => searchOrders({ page: 0 })} className="btn btn-light btn-sm" type="button" title="Tìm kiếm...">
                                <FaSearch />
                              </button>
                            </div>
                          </div>

                          <button onClick={(event) => searchOrders({ page: 0 })} className="btn btn-light btn-sm d-none" type="button" title="Tìm kiếm...">
                            <FaSearch />
                          </button>
                        </form>
                      </div>
                      <div className="col-4 col-md-1 p-0">

                        <div>
                          {reconcilePerm.loaded && reconcilePerm.canCreate && (
                            <button onClick={(e) => prepareChecking(e)} type="button" className="btn btn-info btn-sm me-2 " >
                              Tạo đối soát
                            </button>
                          )}
                        </div>
                      </div>

                    </div>

                  </div>
                </div>
                <section className="p-1 ">
                  <DataTable maxHeight="calc(100vh - 220px)" className="table-normal" data-loading={isLoading}>
                    <table className="table table-striped border-normal table-bordered">
                      <thead className="table-primary">
                        <tr>
                          <th className='sticky' width="21px">
                            <input type="checkbox" title='Check all' className='check_all' onChange={() => handleSelectAll()} />
                          </th>

                          <th className='sticky text-center'>STT</th>
                          <th className="text-center"><span>Ngày</span></th>
                          <th className="text-center">Mã vận đơn TQ</th>
                          <th><span>Tên sản phẩm</span></th>

                          <th className="text-center">Số lượng</th>
                          <th className="text-center"><span data-note="Vnđ">Giá khai</span></th>
                          <th className="text-center"><span data-note="Vnđ">Thành tiền</span></th>

                          <th colSpan="2" className="text-center"><span data-note="%">Thuế NK</span></th>
                          <th colSpan="2" className="text-center"><span data-note="%">VAT</span></th>

                          <th className="text-center"><span>Tổng sau VAT</span></th>
                          <th className="text-center">Phí đầu mục</th>
                          <th className="text-center">Phí ủy thác</th>
                          <th className="text-center">KG</th>
                          <th className="text-center">M3</th>
                          <th className="text-center"><span data-note="Vnđ">Tiền cước</span></th>
                          <th className="text-center"><span data-note="Vnđ">Phụ phí</span></th>
                          <th className="text-center">
                            <span data-note="Vnđ">Phí dịch vụ</span>
                            <span className="filter-ib" data-form="contact_order_vat_filter" data-filter="contactRateStatus" data-source-key="list_rateStatus" data-min="100px"><i className="filter-i"></i></span>
                          </th>
                          <th className="text-center"><span data-note="Vnđ">Tổng phí</span><div className="small">Phí + thuế</div></th>
                          <th className="text-center">Tổng hoàn</th>
                          <th>Ghi chú</th>
                          <th className="text-center">Mã KH</th>
                          <th className="text-center">Mã DT</th>
                        </tr>
                      </thead>
                      {pageOrderData.page && pageOrderData.page.content && pageOrderData.page.content.map((item, index) => (
                        <tbody className="tbody-row" key={index}>
                          <tr>
                            <td className='sticky' title={item.id}>
                              <input
                                type="checkbox"
                                checked={selectedOrders.includes(item.id)}
                                disabled={isContactSelectLocked(item.contactingId)}
                                onChange={() => handleSelectOrder(item.id)}
                              />
                            </td>

                            <td className='sticky text-center' title={`Id: ${item.id}`}>{index + 1}</td>
                            <td className="text-success text-center" title={general.formatTimeShort(item.orderDate)}>{general.formatDate(item.orderDate)}</td>
                            <td className="text-success text-center">{item.cnCode}</td>
                            <td className="text-success text-start text-truncate mw-150" title={`orderId: ${item.orderId}`}>{item.productName}</td>

                            <td className="text-success text-center">{item.quantity}</td>
                            <td className="text-success text-center">{general.formatNumber(item.priceDeclare)}</td>
                            <td className="text-success text-center">{general.formatNumber(item.money)}</td>

                            <td className="text-success text-center">{general.formatDecimal(item.taxImport)}</td>
                            <td className="text-success text-center">{general.formatNumber(item.moneyTaxImport)}</td>

                            <td className="text-success text-center">{general.formatDecimal(item.taxVat)}</td>
                            <td className="text-success text-center">{general.formatNumber(item.moneyVat)}</td>
                            <td className="text-success text-center">{general.formatNumber(item.moneyAfterTax)}</td>

                            <td className="text-success text-center">{general.formatNumber(item.contactFeeItem)}</td>
                            <td className="text-success text-center">{general.formatNumber(item.contactFeeEntrust)}</td>

                            <td className="text-success text-center">{general.formatDecimal(item.weight)}</td>
                            <td className="text-success text-center">{general.formatDecimal(item.size)}</td>
                            <td className="text-success text-center">{general.formatDecimal(item.contactFeeNormal)}</td>
                            <td className="text-success text-center">{general.formatDecimal(item.contactFeeSurcharge)}</td>
                            <td className="text-success text-center">
                              <span className="pe-1">{general.formatDecimal(item.contactFee)}</span>
                              <CheckingTicket checkingId={item.contactingId} checkingName={item.contactingName} />
                            </td>
                            <td className="text-success text-center" title={`Fee: ${general.formatNumber(item.fee)}`}>{general.formatNumber(item.moneyFeeTax)}</td>
                            <td className="text-success text-center"></td>
                            <td className="text-start text-truncate mw-101">{general.mergeText(item.noteAdmin, item.noteUser)}</td>
                            <td className="text-center">{item.customerCode}</td>
                            <td className="text-center">{item.contactCode}</td>
                          </tr>
                        </tbody>
                      ))}


                      <tbody>
                        {errorMessage === '' && pageOrderData.page && pageOrderData.page.content.length === 0 && (
                          <tr>
                            <td colSpan="25" className="text-center">Không tìm thấy dữ liệu</td>
                          </tr>
                        )}
                        {errorMessage !== '' && (
                          <tr>
                            <td colSpan="25" className="text-center">{errorMessage}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </DataTable>
                </section>
              </div>

            </div>


          </div>

          <div className="my-1 d-flex justify-content-end align-items-center">
              <Paging
                pageData={pageOrderData}
                onPageChange={handlePageChange}
                onItemsPerPageChange={handleChangeItemsPerPage}
              />
          </div>


          <input type="hidden" id="editor_lines" value="TMĐT,Line Thường,Line XT" />
          <input type="hidden" id="list_lines" value="TMĐT,Line Thường,Line XT,Line VAT" />
          <input type="hidden" id="list_status" value="Đơn mới,Kho TQ,Xe Về VN,Kho VN,Đang Giao,Đã Nhận" />
          <input type="hidden" id="list_rateStatus" value="Chưa đối soát,Vào phiếu,Đã đối soát" />
          <input type="hidden" id="list_customers" value={customerCodes} />
          <input type="hidden" id="list_vats" value={customerVats} />

          <div className="d-none th-col th filter-check display">
            <span className="filter-ib" data-form="form_filter" data-filter="deletion"><input type="checkbox" /></span>
            <label className="form-check-label">Đã xóa</label>
          </div>
          <div className="d-none th-col th display">
            <span className="filter-ib" data-form="form_filter" data-filter="outdate"></span>
            <label className="form-check-label">Quá hạn</label>
          </div>

          {contactOrderVatData && (
            <ContactOrderVatReview data={contactOrderVatData} handleSearch={handleRefreshPage} />
          )}

        </div >
      </AdLayout>

  </div>
  );
}
export default ContactVatOrders;